export default __webpack_public_path__ + "static/media/fireworks_audio.a0434671.mp3";